export const UTAH_BACKFILL_JOB_TYPE = 'utah_medicaid_835_backfill';

// Keep these verified routes in sync with the backend Utah routes.py contract.
export const UTAH_TARGETS = [
  { siteId: 286, domain: '500072079', npi: '1992144364', label: 'Springville Dermatology — NPI 1992144364' },
  { siteId: 110, domain: '500055257', npi: '1144212416', label: 'Provider NPI 1144212416' },
  { siteId: 110, domain: '500064708', npi: '1639195472', label: 'Provider NPI 1639195472' },
];

export function targetsForSite(siteId) {
  return UTAH_TARGETS.filter(target => String(target.siteId) === String(siteId));
}

function parseDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) throw new Error('Both Pay Cycle Dates are required.');
  const date = new Date(`${value}T00:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) {
    throw new Error('Enter valid Pay Cycle Dates.');
  }
  return date;
}

export function buildUtahBackfillParams({ siteId, domainValue, username, password, fromDate, toDate }) {
  const targets = targetsForSite(siteId);
  const domain = domainValue || (targets.length === 1 ? targets[0].domain : '');
  const target = targets.find(item => item.domain === domain);
  if (!target) throw new Error('Select a configured site and its provider target.');
  if (!username?.trim() || !password?.trim()) throw new Error('UtahID username and password are required.');
  const start = parseDate(fromDate);
  const end = parseDate(toDate);
  const days = (end - start) / 86400000 + 1;
  if (days < 1 || days > 366) throw new Error('Use an inclusive date range of at most 366 days, with the end on or after the start.');
  const format = value => {
    const [year, month, day] = value.split('-');
    return `${month}/${day}/${year}`;
  };
  return { site_id: target.siteId, domain_value: domain, username: username.trim(), password,
    from_date: format(fromDate), to_date: format(toDate) };
}

export function utahBackfillError(values) {
  try { buildUtahBackfillParams(values); return ''; } catch (error) { return error.message; }
}
